import { PrerequisiteRuleTypes, type ExtensionConfig } from '@goto/shell-common'

export const extensionConfig: ExtensionConfig = {
  id: '@ucc/gtc-cc-qm-scorecard.widgets',
  url: new URL('/experiences/cc-qm-scorecard-widgets/goto-app-extension.js', location.origin),
  prerequisites: {
    // TODO: revisit extension prerequisites (SAI-10346)
    [PrerequisiteRuleTypes.SHELL_FEATURE_FLAGS]: 'insights.enable',
  },
  integrations: {
    msTeams: {
      shouldLoadInIntegration: false,
    },
    sidePanel: {
      shouldLoad: true,
    },
  },
}

export default extensionConfig
